export const baseUrls = {
  lottery_url: 'https://ltry.09game.com/lottery?',  //抽奖
  shop_url: 'https://shop.09game.com/shop?',  //商城
  user_url: 'https://users.09game.com/home',  //用户中心
  card_url: 'https://ltry.09game.com/pifu',
  hd_url: 'https://hd.09game.com/box',
  // user_url: 'http://192.168.1.148:6001/home',
  // user_url: 'https://testuser.09game.com/wx_user/home',
  invoice_url: 'https://open.09game.com/invoice', //发票中心
  score_url: 'https://score.09game.com',  //战绩中心
};



// WEBPACK FOOTER //
// ./src/utils/baseUrlConfig.js